import React, { useEffect, useState } from "react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { activeChildDetail, appConstants } from "../../../AtomStore/store";
import { freeBeeLogin } from "../../../QueryFunctions/queryfunction";
import { Browser } from "@capacitor/browser";

const Finance = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const { useMutationWrapper } = useRequestProcessor();
  const [constants] = useAtom(appConstants);
  const navigate = useNavigate();

  const [activeChild] = useAtom(activeChildDetail);

  useEffect(() => {
    console.log("[Finance] Loading finances for child:", activeChild?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFreeBeeLogin = useMutationWrapper(
    "freeBeeLogin",
    (onSuccess) => {
      console.log("[Finance] Calling API: /chargebees/login ", {
        onSuccess: onSuccess,
        child_id: activeChild?.id,
      });
      return freeBeeLogin(onSuccess);
    },
    {
      onSuccess: (data) => {
        console.log("[Finance] Chargebees Login response:", data);
      },
    }
  );

  const goToInvoice = () => {
    const invoiceUrl =
      constants.PaymentCheckUrl + "?child_id=" + activeChild?.id;
    window.open(invoiceUrl, "_blank", "location=no,closebuttoncaption=Back");
  };
  const openCapacitorSite = async (url) => {
    await Browser.open({ url: url });
  };
  const gotToFinance = () => {
    handleFreeBeeLogin.mutate((data) => {
      openCapacitorSite(data.response);
    });
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <div className="mx-2 py-2">
      <div className=" grid grid-cols-12 mt-2 mb-2  gap-2 md:gap-3">
        <div
          onClick={gotToFinance}
          className=" col-span-12 md:col-span-6 grid grid-cols-12 bg-gradient-to-tl from-sky-400 to-sky-700   rounded-lg"
        >
          <div className="col-span-3 rounded-l-lg flex  items-center justify-center">
            <i className="icon-invoice-view text-[60px] text-white text-center"></i>
          </div>
          <h3 className="col-span-9 text-white font-medium flex items-center border-1 border-white  rounded-r-lg pl-2">
            View Invoices
          </h3>
        </div>
        <div
          onClick={goToInvoice}
          className="col-span-12 md:col-span-6 grid grid-cols-12 bg-gradient-to-tl from-sky-400 to-sky-700  rounded-lg"
        >
          <div className="col-span-3   rounded-l-lg flex  items-center justify-center">
            <i className="icon-pay-invoice text-[60px] text-white text-center"></i>
          </div>
          <h3 className="col-span-9 font-medium text-white flex items-center border-1 border-white  rounded-r-lg pl-2">
            Pay Invoices
          </h3>
        </div>
        <div
          onClick={(e) => {
            e.preventDefault();
            navigate("/feeCertificate");
          }}
          className="col-span-12 md:col-span-6 grid grid-cols-12 bg-gradient-to-tl from-sky-400 to-sky-700  rounded-lg"
        >
          <div className="col-span-3  rounded-l-lg flex  items-center justify-center">
            <i className="icon-fee-certificate text-[60px] text-white text-center"></i>
          </div>
          <h3 className="col-span-9 text-white font-medium flex items-center border-1 border-white  rounded-r-lg pl-2">
            Fee Certificate
          </h3>
        </div>
        <div
          onClick={(e) => {
            e.preventDefault();
            navigate("/nonSatisfaction");
          }}
          className="col-span-12 md:col-span-6 grid grid-cols-12 bg-gradient-to-tl from-sky-400 to-sky-700  rounded-lg "
        >
          <div className="col-span-3 rounded-l-lg flex  items-center justify-center">
            <i className="icon-refund text-[60px] text-white text-center"></i>
          </div>
          <h3 className="col-span-9 text-white font-medium flex items-center border-1 border-white  rounded-r-lg pl-2">
            Non-Satisfaction Refund
          </h3>
        </div>
      </div>
      {/* <h3 className='bg-green-600 text-white p-3 rounded-t-lg font-semibold text-lg '>
        Why Credit adjustment did not happen?
    </h3>
    <p className='p-4 bg-green-100 mb-3 rounded-b-lg'>Credits are adjusted in the next month of issue. So if you applied for Pause from July 5th to August 10th, system would only process credit once you have completed your pause period which is on August 11th, since next Invoice is only sent on September 1, these credits would only reflect in that Invoice.</p>
 */}

      <div className="">
        <div
          className={`hs-accordion mb-1 mt-4 ${
            activeIndex === 0
              ? "hs-accordion-active:border-gray-200 active"
              : "bg-gray-500   border border-transparent"
          } rounded-xl dark:${
            activeIndex === 0
              ? "hs-accordion-active:border-neutral-700"
              : "bg-neutral-800 dark:border-transparent"
          }`}
        >
          <button
            className={`hs-accordion-toggle ${
              activeIndex === 0
                ? "hs-accordion-active:text-blue-600 bg-gray-300 rounded-xl"
                : "text-white"
            } inline-flex justify-between items-center  w-full font-medium text-start py-3 px-3 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none dark:${
              activeIndex === 0
                ? "hs-accordion-active:text-blue-500"
                : "text-neutral-200 dark:hover:text-neutral-400 dark:focus:outline-none dark:focus:text-neutral-400"
            }`}
            aria-expanded={activeIndex === 0}
            aria-controls="hs-basic-active-bordered-collapse-1"
            onClick={() => handleToggle(0)}
          >
            Why Credit adjustment did not happen?
            <svg
              className={`hs-accordion-active:hidden block size-3.5 ${
                activeIndex === 0 ? "hidden" : "block"
              }`}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>
            <svg
              className={`hs-accordion-active:block hidden size-3.5 ${
                activeIndex === 0 ? "block" : "hidden"
              }`}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
            </svg>
          </button>
          <div
            id="hs-basic-active-bordered-collapse-1"
            className={`hs-accordion-content ${
              activeIndex === 0 ? "block" : "hidden"
            } w-full overflow-hidden transition-[height] duration-300`}
            role="region"
            aria-labelledby="hs-active-bordered-heading-1"
          >
            <div className="p-2 px-4">
              <p className="text-gray-800 dark:text-neutral-200">
                <em>{constants.CreditsAdjustedInvoice}</em>
              </p>
            </div>
          </div>
        </div>

        <div
          className={`hs-accordion ${
            activeIndex === 1
              ? "hs-accordion-active:border-gray-200 active"
              : "bg-red border border-transparent"
          } rounded-xl dark:${
            activeIndex === 1
              ? "hs-accordion-active:border-neutral-700"
              : "bg-neutral-800 dark:border-transparent"
          }`}
        >
          <button
            className={`hs-accordion-toggle ${
              activeIndex === 1
                ? "hs-accordion-active:text-blue-600  bg-gray-300 rounded-xl"
                : "text-white"
            } inline-flex justify-between items-center  w-full font-medium text-start py-3 px-3 hover:text-gray-500 disabled:opacity-50 disabled:pointer-events-none dark:${
              activeIndex === 1
                ? "hs-accordion-active:text-blue-500"
                : "text-neutral-200 dark:hover:text-neutral-400 dark:focus:outline-none dark:focus:text-neutral-400"
            }`}
            aria-expanded={activeIndex === 1}
            aria-controls="hs-basic-active-bordered-collapse-2"
            onClick={() => handleToggle(1)}
          >
            Stop Reminders
            <svg
              className={`hs-accordion-active:hidden block size-3.5 ${
                activeIndex === 1 ? "hidden" : "block"
              }`}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>
            <svg
              className={`hs-accordion-active:block hidden size-3.5 ${
                activeIndex === 1 ? "block" : "hidden"
              }`}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
            </svg>
          </button>
          <div
            id="hs-basic-active-bordered-collapse-2"
            className={`hs-accordion-content ${
              activeIndex === 1 ? "block" : "hidden"
            } w-full overflow-hidden transition-[height] duration-300`}
            role="region"
            aria-labelledby="hs-active-bordered-heading-2"
          >
            <div className="p-2 px-4">
              <p className="text-gray-800 dark:text-neutral-200">
                <em>{constants.StopRemindersText}</em>
              </p>
              <div className="flex  gap-x-2 mt-4 mb-6 ">
                <button
                  onClick={() => {
                    navigate("/raiseAnIssue");
                  }}
                  className="flex-1 min-w-0 bg-red-600 text-white font-semibold rounded-full  hover:border-red-600 hover:bg-red-500 hover:text-white shadow-md py-2 px-6 inline-flex items-center justify-center"
                >
                  <span className="mr-2">Already Withdrawn</span>
                </button>
                <button
                  onClick={() => {
                    goToInvoice();
                  }}
                  className="flex-1 min-w-0 bg-green-600 text-white font-semibold rounded-full  hover:border-green-600 hover:bg-green-500 hover:text-white shadow-md py-2 px-6 inline-flex items-center justify-center"
                >
                  <span className="mr-2">Already Paid</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <h3 className="bg-red-600 text-white p-3 rounded-t-lg font-semibold text-lg ">
        Stop Reminders
      </h3>
      <p className="p-4  bg-red-100 mb-3 rounded-b-lg">
        We are extremely sorry if you have already paid and still facing
        reminders, please provide details so that we can update our system and
        stop sending updates.
      </p>
      <div className="flex  gap-x-2 ">
        <button className=" flex-1 min-w-0 bg-red-600 text-white font-semibold rounded  hover:border-red-600 hover:bg-red-500 hover:text-white shadow-md py-2 px-6 inline-flex items-center justify-center">
          <span className="mr-2">Already Withdrawn</span>
        </button>
        <button className="flex-1 min-w-0 bg-green-600 text-white font-semibold rounded  hover:border-green-600 hover:bg-green-500 hover:text-white shadow-md py-2 px-6 inline-flex items-center justify-center">
          <span className="mr-2">Already Paid</span>
        </button>
      </div> */}
    </div>
  );
};

export default Finance;
